import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { IconProps } from '@amelio/ui-library';

import { EvaluationType } from '@/constants/cycle-evaluation/CycleEvaluation';

const EVALUATION_TYPE_ICON_NAMES: Record<EvaluationTypeValue, IconProps['name']> = {
    [EvaluationType.MANAGER_EVALUATION]: 'edit-clipboard-tick',
    [EvaluationType.EVALUATION_360]: 'users-people',
    [EvaluationType.SELF_EVALUATION]: 'users-user',
};

export { EVALUATION_TYPE_ICON_NAMES };
